<template>
  <header class="Header" role="banner">
    <div class="Header_wrapper">
      <div class="Header_infos">
        L’information experte et référente sur la qualite du logement par la seule association, indépendante et à but non lucratif, engagée depuis 1974
        <div class="Header_back">
          <a href="https://www.qualitel.org/" target="_blank" @click="$gtm.trackEvent({ category: 'button_link', action: 'click', label: 'header_qualitel_org' })">Qualitel.org <img src="../../../public/static/images/arrow-topright.svg" /></a>
        </div>
      </div>
      <div class="Header_content" v-if="!isMobile">
        <div class="Header_content_wrapper">

          <router-link :to="{ name: 'home' }" @click.native="$gtm.trackEvent({ category: 'button_head_logo', action: 'click', label: 'header_logo_asso' })"><img class="Header_logo" src="../../../public/static/images/qualitel-logo.svg" alt="Qualitel - Pour la qualité du logement" /></router-link>
          <nav class="Header_nav" role="navigation">
            <ul>
              <li><router-link :to="{ name: 'survey', params: { slug:  'qualiscore' } }" @click.native="$gtm.trackEvent({ category: 'button_menu_item', action: 'click', label: 'header_donnees' })">Les résultats</router-link></li>
              <li><router-link :to="{ name: 'page', params: { slug:  'analyse' } }" @click.native="$gtm.trackEvent({ category: 'button_menu_item', action: 'click', label: 'header_analyse' })">L'analyse</router-link></li>
              <li><a href="https://www.qualitel.org/barometre-qualitel/" target="_blank" @click="$gtm.trackEvent({ category: 'button_menu_item', action: 'click', label: 'header_apropos' })">À propos du Baromètre Qualitel</a></li>
              <li><router-link :to="{ name: 'qualiscore'}"><button class="Cta Cta_line" @click="$gtm.trackEvent({ category: 'button_cta', action: 'click', label: !user.surveys || user.surveys.qualiscore.completed == false ? 'header_jevalue' : 'header_mon_evaluation' })">{{ !user.surveys || user.surveys.qualiscore.completed == false ? "J'évalue mon logement" : 'Mon évaluation' }}</button></router-link></li>
            </ul>
          </nav>
        </div>
      </div>

      <div class="Header_content" v-else>
        <div class="Header_content_wrapper">

          <router-link :to="{ name: 'home' }" @click.native="$gtm.trackEvent({ category: 'button_head_logo', action: 'click', label: 'header_logo_asso' })"><img class="Header_logo" src="../../../public/static/images/qualitel-logo.svg" alt="Qualitel - Pour la qualité du logement" /></router-link>
          <div class="Header_burger" @click="isOpen = !isOpen" :class="{ 'Header_burger_active' : isOpen }">
            <div class="Header_burger_wrapper">
              <span></span>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>

          <transition name="panel">
            <nav class="Header_nav" role="navigation" v-show="isOpen">
              <ul>
                <li><router-link :to="{ name: 'home' }" @click.native="$gtm.trackEvent({ category: 'button_menu_item', action: 'click', label: 'header_accueil' })">Accueil</router-link></li>
                <li><router-link :to="{ name: 'survey', params: { slug:  'qualiscore' } }" @click.native="$gtm.trackEvent({ category: 'button_menu_item', action: 'click', label: 'header_donnees' })">Les résultats</router-link></li>
                <li><router-link :to="{ name: 'page', params: { slug:  'analyse' } }" @click.native="$gtm.trackEvent({ category: 'button_menu_item', action: 'click', label: 'header_analyse' })">L'analyse</router-link></li>
                <li><a href="https://www.qualitel.org/barometre-qualitel/" @click="$gtm.trackEvent({ category: 'button_menu_item', action: 'click', label: 'header_apropos' })" target="_blank">À propos du Baromètre Qualitel</a></li>
                <li><a href="https://www.qualitel.org/" target="_blank" @click="$gtm.trackEvent({ category: 'button_link', action: 'click', label: 'header_qualitel_org' })">Qualitel.org</a></li>
              </ul>

              <router-link :to="{ name: 'qualiscore'}"><button class="Cta Cta_red" @click="$gtm.trackEvent({ category: 'button_cta', action: 'click', label: !user.surveys || user.surveys.qualiscore.completed == false ? 'header_jevalue' : 'header_mon_evaluation' })">{{ !user.surveys || user.surveys.qualiscore.completed == false ? "J'évalue mon logement" : 'Mon évaluation' }}</button></router-link>
            </nav>
          </transition>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import { TweenMax, ScrollToPlugin } from 'gsap/all'

  export default {
    name: "Header",
    data() {
      return {
        isShow: true,
        isMobile: false,
        isOpen: false
      }
    },
    computed: {
      ...mapState([
        'user'
      ])
    },
    watch: {
      $route()
      {
        this.isOpen = false
      },
      isOpen()
      {
        let filters = document.body.querySelector('.FiltersBlockMobile')
        if(this.isOpen)
        {
          if(filters)
            TweenMax.to(filters, 0.3, { y: '100%', ease: Power4.easeOut })
          this.$tools.disableScroll()
        }else
        {
          if(filters)
            TweenMax.to(filters, 0.6, { y: '0%', delay: 0.3, ease: Power4.easeOut })
          this.$tools.enableScroll()
        }
      }
    },
    methods: {
      onResize()
      {
        if(window.innerWidth <= 960)
        {
          this.isMobile = true
        }else{
          this.isMobile = false
        }
      }
    },
    mounted()
    {
      window.addEventListener('resize', this.onResize)
      this.onResize()
    }
  }
</script>

<style lang="stylus" scoped>
.Header

  position relative
  top 0px
  left 0px
  right 0px
  box-sizing border-box
  width 100%
  z-index 100
  background-color white
  transition opacity 1s $ease

  @media $medium

    position fixed

  &_burger

    width 75px
    height 100%
    position absolute
    top 0px
    right 0px
    display flex
    align-items center
    cursor pointer
    justify-content center
    border-left 1px solid $n1

    &_active

      span

        &:nth-child(1)

          width 0%

        &:nth-child(2)

          transform translateX(-50%) rotate(320deg)!important

        &:nth-child(3)

          width 0%

        &:nth-child(4)

          transform translateX(-50%) rotate(220deg)!important
          width 100%!important
          opacity 1!important

    &_wrapper

      position relative
      margin auto
      height 18px
      width 26px

    span

      width 100%
      height 2px
      border-radius 3px
      background-color $red
      display block
      position absolute
      // transition 0.8s $ease

      &:nth-child(1)

        top 0px
        right 0px

      &:nth-child(2)

        top calc(50% - 1.5px)
        left 50%
        transform translateX(-50%)

      &:nth-child(3)

        bottom 0px
        left 0px

      &:nth-child(4)

        top calc(50% - 1.5px)
        left 50%
        transform translateX(-50%)
        // transition-duration 0.6s
        width 0%
        opacity 0

  &_infos

    font-size: 13px;
    color: #1A1A1A;
    line-height: 30px;
    word-wrap none
    height 30px
    padding 0px 25px
    // max-width $max
    margin auto
    display flex
    flex-direction row
    align-items flex-start
    justify-content space-between

    @media $medium

      display none

  &_content

    position relative
    height 110px
    box-sizing border-box
    border-top 1px solid $n1
    border-bottom 1px solid $n1
    padding 0px 25px

    @media $medium

      padding 0px $s-xs
      height 60px

    &_wrapper

      // max-width $max
      margin auto
      width 100%
      height 100%
      display flex
      flex-direction row
      align-items center
      justify-content space-between

  &_logo

    width 225px
    height 56px

    @media $medium

      width 125px
      height 32px

  &_back

    font-size: 14px;
    color: $s1
    letter-spacing: 0;
    margin 0px 0px 0px auto
    text-align right
    display inline
    color #1A1A1A;

    img

      margin-left 5px
      display inline-block

    @media $medium

      margin 0px auto
      text-align center
      padding 30px 0px
      border-top 1px solid $n1

    a

      cursor pointer
      color inherit
      text-decoration none
      transition 0.3s $ease

      @media $medium

        font-size 14px!important
        line-height 14px!important
        color $s1!important

      &:hover

        color $blue

    i

      margin-right 15px

      @media $medium

        margin-right 8px

  &_nav

    width 100%
    max-width 720px

    @media $medium

      max-width none
      display flex
      flex-direction column
      align-items center
      justify-content space-between
      position fixed
      height calc(100vh - 60px)
      height calc((100vh - 60px) - var(--vh, 0px));
      bottom 0px
      left 0px
      right 0px
      overflow-y auto
      background-color white
      box-sizing border-box

      button

        margin-bottom 40px
        width calc(100vw - 25px - 25px)

    &.panel-enter, &.panel-leave-to

      @media $small

        transform translate3d(100%, 0%, 0px)

    ul

      margin 0px
      padding 0px
      list-style none
      display flex
      flex-direction row
      align-items center
      justify-content space-between
      width 100%

      @media $medium

        flex-direction column
        margin 0px auto
        text-align left

    a

      font-size: 18px;
      color: #1A1A1A;
      text-decoration none
      letter-spacing: 0;
      line-height: 18px;
      transition .3s $ease

      @media $medium

        font-size 16px
        line-height 24px

        &.router-link-exact-active

          font-weight 600
          color $red

    li

      position relative

      @media $medium

        padding 30px 25px
        box-sizing border-box
        width 100%
        border-bottom 1px solid #E8E9F0

        &:last-child

          border-bottom none

      @media $xsmall

        padding 15px 25px
        box-sizing border-box
        width 100%

      &:hover

        a

          color $red

</style>
